import React, { useState, useEffect } from 'react'
import { Col, Container, Row, Button } from 'react-bootstrap'
import { IoIosArrowBack, BiRightArrowAlt } from 'react-icons/all'
import { useNavigate } from 'react-router-dom';
import { HiClipboardDocumentList } from "react-icons/hi2";
import { HiOutlineDocumentSearch } from 'react-icons/hi'
import { AiFillPlusCircle } from 'react-icons/ai'
import { Tab, Tabs, Form, Modal, ModalBody, InputGroup } from "react-bootstrap";
import { useSelector } from 'react-redux';
import { AXIOS, api_key } from "../../config";
import { toast } from "react-toastify";
import Select from 'react-select';
import { type } from 'os';

// import './withdraw_styles/withdraw_head.css'

export default function AddressBoook() {
   
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedCoin, setSelectedCoin] = useState({});
    const [selectedNetwork, setSelectedNetwork] = useState({});
    const [listOfNetworks, setListOfNetworks] = useState([])
    const [selectedValues, setSelectedValues] = useState({
        selectedCoin:{
            value: '',
            label: '',
            coinId: '',
            imgUrl: '',
            contentType: ''
        },
        selectedNetwork:{
            value: '',
            label: '',
         
        }
    });
    const [options, setOptions] = useState(useSelector((state: any) => state.coinList))

    const navigate = useNavigate();
    function openModal() {
        setModalOpen(true);
    }
    function closeModal() {
        setModalOpen(false);
    }
    const getNetworkslist = async () => {
        try {
            const response = await AXIOS.post('/depositNetworkList', {
                api_key: api_key,

            });

            console.log('network response', response.data.data)

            const options = response.data.data.map((network: any) => ({
                value: network.symbol,
                label: network.name,
                networkId: network._id
            }));


            setListOfNetworks(options);
        }
        catch (error: any) {
            toast.error(error.message)
        }
    }
    useEffect(() => {
        getNetworkslist();
        (async function () {
            try {
                const response = await AXIOS.post('/getCoinList', {
                    api_key: api_key,

                });

                const options = response.data.data.map((coin: any, index: number) => ({
                    value: coin.symbol,
                    label: coin.name,
                    coinId: coin._id,
                    imgUrl: coin.image_url.img.data,
                    contentType: coin.image_url.img.contentType
                }));
                setOptions(options)

            }
            catch (error: any) {
                toast.error(error.message)
            }
        })();

    }, []);

    const handleSelectChange = (selectedOption, selectName) => {
        setSelectedValues(prevState => ({
            ...prevState,
            [selectName]: selectedOption ? selectedOption : {
                label:'',
                value:''
            },
        }));
    };

    const getCoinofNetwork=async()=>{
        let response=await AXIOS
           .post('getCoinOfNetwork', {
             api_key: api_key,
             name: selectedValues.selectedCoin.label,
             symbol: selectedValues.selectedCoin.value,
             network:selectedValues.selectedNetwork.label
     
           })
           let coinId= response.data.data._id
        //    dispatch(updateCoinOfNetwrokId(response.data.data._id))
       }
       
       useEffect(() => {
         if (selectedValues.selectedCoin.label !='' && selectedValues.selectedNetwork.label !=='') {
           getCoinofNetwork()
         }
     
       }, [selectedValues]);

    return (
        <>
            <div className='withdraw mb-4'>
                <Container>
                    <Row>
                        <Col className="">
                            <div className="withdraw_content d-flex gap-3 align-items-center" onClick={() => { navigate(-1) }} style={{ cursor: 'pointer' }}>
                                <i className="" style={{ fontSize: '1.8rem' }}>
                                    <IoIosArrowBack />
                                </i>
                                <h3 className='m-0'>Withdrawal address management</h3>
                            </div>
                        </Col>
                    </Row>
                    <div
                        className="d-flex flex-column align-items-center justify-content-center"
                        style={{ color: "var(--text-clr)" }}
                    >


                        <i className="display-2">
                            <HiOutlineDocumentSearch />
                        </i>
                        <span className='text-muted small mt-3'>Save frequently used addresses in the address book, which can be used directly when withdrawing funds in the future. Address setting notes will be more helpful for your address management</span>
                    </div>
                    <div className="d-flex justify-content-center align-items-center" style={{ marginTop: "6rem" }}>
                        <Button className='bg-warning border-0 text-white' style={{ fontSize: "1.5rem" }} onClick={() => { openModal() }}> <AiFillPlusCircle />  Add</Button>

                    </div>
                </Container>
            </div>
            <Modal show={isModalOpen} onHide={closeModal} centered backdrop={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Add New Address</Modal.Title>
                </Modal.Header>
                <ModalBody>

                    <Form>
                        <Form.Group className="mb-3" controlId="currency">
                            <Form.Label>Currency</Form.Label>
                            <Select
                                options={options}
                                isSearchable={true}

                                placeholder='select coin'
                                onChange={(option) => handleSelectChange(option, 'selectedCoin')}
                                components={{ Option: CustomOption }}
                            />

                        </Form.Group>
                        <Form.Group className="mb-3" controlId="network">
                            <Form.Label>Network</Form.Label>
                            <Select
                                options={listOfNetworks}
                                isSearchable={true}
                                placeholder='choose network to transfer'
                                onChange={(option) => handleSelectChange(option, 'selectedNetwork')}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="address">
                            <Form.Label>Address</Form.Label>
                            <Form.Control type="text" placeholder="Enter Address" />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="walletLabel">
                            <Form.Label>Wallet Label</Form.Label>
                            <Form.Control type="text" placeholder="Enter remarks" />
                        </Form.Group>

                    </Form>

                    <div className="d-flex justify-content-center align-items-center gap-2" style={{ marginTop: "6rem" }}>
                        <Button className='' variant="light" onClick={() => closeModal()}>Cancel</Button>
                        <Button variant="light">Save</Button>

                    </div>
                </ModalBody>
            </Modal>
        </>
    )
}

const CustomOption = ({ data, innerProps }) => (
    <div {...innerProps} className='py-2'>
        <img src={`data:${data.contentType};base64, ${data.imgUrl}`} className='img-fluid mx-2' width={35} height={35} />

        {data.label}
    </div>
);

